// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BulletinOutlinedSvg from "@fishx/icons-svg/es/asn/BulletinOutlined";
import FishxIcon from '../components/FishxIcon';

var BulletinOutlined = function BulletinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BulletinOutlinedSvg
  }));
};

BulletinOutlined.displayName = 'BulletinOutlined';
export default React.forwardRef(BulletinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BulletinOutlined.js
// module id = 2133
// module chunks = 0